import { createSelector } from 'reselect'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import currentViewSelector from 'redux/selectors/ui/currentViewSelector'
import viewTypes from 'helpers/enums/viewTypes'

const getUserData = state => state.user
const onboardingGuideCardsSelector = state => state.onboardingGuide.cards

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.NAV_TOPBAR,
	featureFlagsTypes.ONBOARDING_GUIDE,
])

const getNavigationMenuHelpData = createSelector(
	[getUserData, featureFlagsSelector, onboardingGuideCardsSelector, currentViewSelector],
	(userData, featureFlags, onboardingGuideCardsData, currentView) => {

		const shouldShowOnboardingGuideButton = featureFlags[featureFlagsTypes.ONBOARDING_GUIDE] &&
			onboardingGuideCardsData.length === 0 && currentView === viewTypes.LIBRARY

		return {
			userData: userData.data,
			shouldAddPeronsalizedNews: featureFlags[featureFlagsTypes.NAV_TOPBAR],
			shouldShowOnboardingGuideButton,
		}
	}

)

export default getNavigationMenuHelpData
